import { request } from './http';
import { CurrentUser } from './types';

export const getCurrentUser = () => request<CurrentUser>('/user', 'GET');

export const updateCurrentUser = (body: {
  name?: string | null;
  avatarUrl?: string | null;
}) =>
  request<
    Pick<CurrentUser, 'id' | 'email' | 'name' | 'avatarUrl'>,
    typeof body
  >('/user', 'PATCH', body);

export const updatePassword = (body: {
  currentPassword: string;
  newPassword: string;
}) => request<{ message: string }, typeof body>('/user/password', 'POST', body);

export const deleteCurrentUser = () =>
  request<{ message: string }>('/user', 'DELETE');
